import { Row, Col, Card, Button } from 'react-bootstrap';

interface RetailHealthData {
  ID: number;
  CrmClientID: string;
  Name: string;
  PhoneNumber: string;
  Email: string;
  EmployeeNumber: string;
  LeadType: string;
  Requirements: string;
  InsertDateTime: string;
}

type Props = {
  requests: RetailHealthData[];
  onAddRequest: () => void;
};

const RetailHealthList: React.FC<Props> = ({ requests, onAddRequest }) => {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h6 className="mb-0">Your Requests ({requests.length})</h6>
        <Button variant="primary" size="sm" onClick={onAddRequest}>
          + Add Request
        </Button>
      </div>
      <Row>
        {requests.map((request) => {
          return (
            <Col md={12} key={request.ID} className="mb-4">
              <Card className="shadow-sm border-0">
                <Card.Header className="bg-primary text-white">
                  <div className="d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">{request.LeadType}</h5>
                    
                  </div>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Contact Information</h6>
                      <p className="mb-2"><strong>Name:</strong> {request.Name}</p>
                      <p className="mb-2"><strong>Email:</strong> {request.Email}</p>
                      <p className="mb-2"><strong>Phone:</strong> {request.PhoneNumber}</p>
                    </Col>
                    <Col md={6}>
                      <h6 className="text-muted mb-3">Request Details</h6>
                      <p className="mb-2"><strong>Lead Type:</strong> {request.LeadType}</p>
                      <p className="mb-2"><strong>Requirements:</strong> {request.Requirements}</p>
                    </Col>
                  </Row>
                  <hr />
                  <p className="mb-0 text-muted small">Submitted: {new Date(request.InsertDateTime).toLocaleDateString()}</p>
                </Card.Body>
              </Card>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export { RetailHealthList };
export type { RetailHealthData };
